'use client';

import { ApolloProvider } from '@apollo/client';

import { TChildrenProps } from '@/models/components';
import getClient from '@/services/apollo';

interface ICustomApolloProviderProps extends TChildrenProps {
	accessToken?: string;
}

const CustomApolloProvider = ({ children, accessToken }: ICustomApolloProviderProps) => (
	<ApolloProvider client={getClient(accessToken)}>{children}</ApolloProvider>
);

export default CustomApolloProvider;
